import columns from "./columns";
import formFields from "./formFields";
import previewFields from "./previewFields";

export default {
    entityName: "organizationContracts",
    pageTitle: "Client Contracts",
    displayName: "clientContracts",
    columns,
    formFields,
    previewFields,
    tableOptions: {},
    formOptions: {},
};
